import { Entity } from './types'


export const columnKeysLeft = [Entity.Count]
export const columnKeysLeftHeaders = [columnKeysLeft]

export const createColumnKeysMain = () => {
  return [Entity.Category, Entity.Students, Entity.Compensation, Entity.TotalRow]
}

export const createColumnKeysMainHeaders = () => {
  return [createColumnKeysMain()]
}
